import styled from "styled-components";

const StyledPaymentCheckoutLayout = styled.div`
  margin: 1rem 0 3rem 0;
`;

export { StyledPaymentCheckoutLayout };
